var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_12240",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(-1322 -194)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1322, 194)",
    filter: "url(#Path_12240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12240-2",
    "data-name": "Path 12240",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(9 6)",
    fill: "#2D53DA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-3556018",
    transform: "translate(1167.731 106.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12441",
    "data-name": "Path 12441",
    d: "M268.694,100.8a2.894,2.894,0,0,0-2.061.854l-4.86,4.86a4.639,4.639,0,0,0-1.368,3.3V112h2.187a4.638,4.638,0,0,0,3.3-1.368l4.863-4.863a2.916,2.916,0,0,0-2.061-4.975Zm.74,3.656-4.861,4.86a2.783,2.783,0,0,1-1.982.822h-.32v-.32a2.782,2.782,0,0,1,.819-1.982l4.863-4.863a1.048,1.048,0,1,1,1.48,1.48Z",
    transform: "translate(-85.869 0)",
    fill: "#fff",
    stroke: "#2D53DA",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12442",
    "data-name": "Path 12442",
    d: "M173.6,137.207h8.4a2.8,2.8,0,0,0,2.8-2.8v-3.735h-1.868v3.735a.934.934,0,0,1-.934.934h-8.4a.933.933,0,0,1-.934-.934V126a.934.934,0,0,1,.934-.934h3.735V123.2H173.6a2.8,2.8,0,0,0-2.8,2.8v8.4a2.8,2.8,0,0,0,2.8,2.8Z",
    transform: "translate(0 -21.468)",
    fill: "#fff",
    stroke: "#2D53DA",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fc41732101288fda3fac9abac9b9de3f.svg";
export { ForwardRef as ReactComponent };